'use client';

import { createContext, useContext } from 'react';
import { useSession } from 'next-auth/react';
import { usePushNotifications, type UsePushNotifications } from '@/lib/hooks/use-push-notifications';

const PushContext = createContext<UsePushNotifications | null>(null);

export default function PushNotificationProvider({ children }: { children: React.ReactNode }) {
  const { status } = useSession();
  const push = usePushNotifications(status === 'authenticated');

  return <PushContext.Provider value={push}>{children}</PushContext.Provider>;
}

/**
 * Access push state/actions under the provider — e.g. an
 * "Enable notifications" button: const { permission, enablePush } = usePush().
 */
export function usePush(): UsePushNotifications {
  const ctx = useContext(PushContext);
  if (!ctx) throw new Error('usePush must be used within a PushNotificationProvider');
  return ctx;
}
